import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useMessages } from "@/hooks/useMessages";
import { ThreadList } from "@/components/messages/ThreadList";
import { ChatPane } from "@/components/messages/ChatPane";

export default function Messages() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { otherId, listingId } = useParams();
  const { threads, active, setActive, msgs, send } = useMessages(user, otherId, listingId);
  const [mobileShowChat, setMobileShowChat] = useState(Boolean(otherId && listingId));

  useEffect(() => { if (!loading && !user) navigate("/login"); }, [loading, user, navigate]);

  if (!user) return null;

  const selectThread = (t) => { setActive(t); setMobileShowChat(true); };

  return (
    <div className="max-w-[1400px] mx-auto px-4 md:px-8 mt-8" data-testid="messages-page">
      <h1 className="font-display text-3xl md:text-5xl uppercase border-b-2 border-black pb-2">/ Messages</h1>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-0 mt-6 border-2 border-black h-[calc(100dvh-220px)] min-h-[420px] md:h-[600px]">
        <ThreadList
          threads={threads}
          activeId={active?.thread_id}
          onSelect={selectThread}
          className={`${mobileShowChat ? "hidden" : "block"} md:block md:col-span-4 md:border-r-2 border-black overflow-y-auto`}
        />
        <ChatPane
          active={active}
          msgs={msgs}
          userId={user.user_id}
          onSend={send}
          onBack={() => setMobileShowChat(false)}
          className={`${mobileShowChat ? "flex" : "hidden"} md:flex md:col-span-8 flex-col min-h-0`}
        />
      </div>
    </div>
  );
}
